import { useEffect, useState } from 'react';
import { createJazzClient, createJazzWebSdk, createSdkToken, JazzSdk } from '@salutejs/jazz-sdk-web';
import { audioOutputMixerPlugin, logsPlugin, videoElementPoolPlugin } from '@salutejs/jazz-sdk-web-plugins';
import { useJazzGlobalContext } from '../../contexts/JazzGlobalContext';
import { handleError } from '../handleError';
import key from '../../key.json';

export const useJazzSDK = ({user, serverUrl}) => {
    const { devices } = useJazzGlobalContext();
    const [ sdk, setSDK ] = useState<JazzSdk | null>(null);
    const [ sdkToken, setSDKToken ] = useState<string | null>(null);
    const [ client, setClient ] = useState(null);
    useEffect(() => {
        if (!user) { return; }
        createJazzWebSdk({
            userAgent: 'Otvet SberJazz',
            plugins: [
                videoElementPoolPlugin(),
                audioOutputMixerPlugin(),
                logsPlugin({
                    logLevel: 'error',
                    isEnableStdout: true,
                }),
            ],
            audioInputDeviceId: devices.getAudioInput(),
            audioOutputDeviceId: devices.getAudioOutput(),
            videoInputDeviceId: devices.getVideoInput(),
        })
            .then((sdk) => {
                setSDK(sdk)
            })
            .catch((err) =>{
                handleError(err, 'Ошибка при инициализации SDK');
            });

        createSdkToken(key, {
            iss: 'JazzTestApp',
            userName: user.username,
            sub: `${user.username}`
        }).then(async ({ sdkToken }) => {
            // sdkToken - транспортный токен
            setSDKToken(sdkToken);
        }).catch((err) => {
            handleError(err, 'Ошибка при создании SDK токена');
        });

        return () => {
            setSDK(null);
            setSDKToken(null)
            setTimeout(() => {
                sdk?.destroy();
            }, 0);
        };

    }, [user]);

    useEffect(() => {
        if (sdk && sdkToken) {
            createJazzClient(sdk, { serverUrl }).then((client) => {
                return client.auth.loginBySdkToken(sdkToken)
                    .then((result) => {
                        if (!result) {
                            throw new Error('Ошибка авторизации с помощью SDK Token')
                        }
                        setClient(client);
                    });
                // return client.auth.setAuthToken(accessToken)
                //     .then((result) => {
                //         if (!result) {
                //             throw new Error('Ошибка авторизации с помощью SDK Token')
                //         }
                //         console.log(result, client, client.auth.userInfo.get())
                //         setClient(client);
                //     });
            }).catch((err) => {
                handleError(err, 'Ошибка авторизации SDK');
            })
        }
    }, [sdk, sdkToken]);

    return {
        sdk,
        client
    }
}
